module.exports = __webpack_public_path__ + "static/media/drumstick.7e506314.svg";